import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class NavbarCollapseComponent extends Component {
  @tracked isOpen = this.args.isOpen ?? false;
  @service betaToggle;
  @service store;

  @action
  toggleCollapse() {
    this.isOpen = !this.isOpen;
  }

  @action
  collapseMenu() {
    if (this.isOpen === false) return;
    this.isOpen = false;
  }

  @action
  onMobileMenuItemClick() {
    this.args.onMobileMenuItemClick();
  }

  @action
  loadTeams() {
    if (this.args.loadTeams) this.store.findAll('team');
  }
}
